import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Jinsihou from '@/components/jinsihou'
import Lanhua from '@/components/lanhua'
import hsMouse from '@/components/hsMouse'
import ccnughzy from '@/components/ccnughzy'
import GuoCaodi from '@/components/cczyy/GuoCaodi'
import PaXueshan from '@/components/cczyy/PaXueshan'
import Yangjingyu from '@/components/cczyy/Yangjingyu'
import YuduStadium from '@/components/cczyy/YuduStadium'
import ZunYiHuiyi from '@/components/cczyy/ZunYiHuiyi'

import Daqiao from '@/components/cczyy/Daqiao'
import Diaosu from '@/components/cczyy/Diaosu'
import Dukou from '@/components/cczyy/Dukou'
import Shitou from '@/components/cczyy/Shitou'
import Jinianbei from '@/components/cczyy/Jinianbei'

import EarthQuake from '@/components/other/EarthQuake'
import course from '@/components/DLMZ/course'
import EarthQuake2 from  '@/components/other/earth2'
import test from '@/components/DLMZ/test'
import versionTood from '@/libs/versionUpdate'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/jinsihou',
      name: 'Jinsihou',
      component: Jinsihou
    },
    {
      path: '/lanhua',
      name: 'Lanhua',
      component: Lanhua
    },
    {
      path: '/GuoCaodi',
      name: 'GuoCaodi',
      component: GuoCaodi
    },
    {
      path: '/YuduStadium',
      name: 'YuduStadium',
      component: YuduStadium
    }, {
      path: '/PaXueshan',
      name: 'PaXueshan',
      component: PaXueshan
    },
    {
      path: '/Yangjingyu',
      name: 'Yangjingyu',
      component: Yangjingyu
    },
    {
      path: '/ZunYiHuiyi',
      name: 'ZunYiHuiyi',
      component: ZunYiHuiyi
    },


    {
      path: '/Daqiao',
      name: 'Daqiao',
      component: Daqiao
    },
    {
      path: '/Diaosu',
      name: 'Diaosu',
      component: Diaosu
    },
    {
      path: '/Dukou',
      name: 'Dukou',
      component: Dukou
    },
    {
      path: '/Shitou',
      name: 'Shitou',
      component: Shitou
    },
    {
      path: '/Jinianbei',
      name: 'Jinianbei',
      component: Jinianbei
    },
    {
      path: '/smg',
      name: 'hsMouse',
      component: hsMouse
    },
    {
      path: '/ccnughzy',
      name: 'ccnughzy',
      component: ccnughzy
    },
    {
      path: '/earthQuake',
      name: 'EarthQuake',
      component: EarthQuake
    },
    {
      path: '/course',
      name: 'course',
      component: course
    },
    {
      path: '/earthQuake2',
      name: 'EarthQuake2',
      component: EarthQuake2
    },
    {
      path: '/test',
      name: 'test',
      component: test
    }
  ]
})

/*router.beforeEach(( to, from, next ) => {
  //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
  versionTood.isNewVersion();
  next();
})*/
//export default router;




// WEBPACK FOOTER //
// ./src/router/index.js